// extracted by mini-css-extract-plugin
export default {"middleIconBox":"ExpandCollapseIcon_middleIconBox__VQS97","expanded":"ExpandCollapseIcon_expanded__Ulbnl"};